/* global firebase */
import { call, put, take, takeEvery, takeLatest, select } from 'redux-saga/effects'
import Logger from '../services/logger';
import createSocketEventChannel from './channel-socket';
import createUserAuthChannel from './channel-auth';
import SocketService from '../services/socket';
import fetch from '../services/fetch';
import { store } from 'react-redux';
import firebase from 'firebase';
import {  } from '../contracts/index';
import {
    MODAL_SHOW, MODAL_METAMASK_NOT_INSTALLED, MODAL_METAMASK_NOT_CONFIGURED, APP_STARTUP_NETWORK, SCREEN_GAME, APP_STARTUP, APP_STARTUP_SOCKET, USER_SET_INTRO_FAIL, USER_SET_INTRO_SUCCESS, USER_SET_INTRO, SCREEN_USER_SET_REFERRAL, USER_SET_REFERRAL_COMPLETE, USER_SET_REFERRAL, USER_UPDATE, USER_AUTH_REGISTER, NAV_SCREEN_AUTH, NAV, SCREEN_AUTH, SCREEN_GENERAL_LOBBY, USER_AUTH_REGISTER_SUCCESS, USER_AUTH_REGISTER_FAIL, SCREEN_USER_SET_USERNAME, USER_SET_REFERRAL_FAIL, USER_SET_USERNAME, USER_SET_USERNAME_FAIL, USER_SET_USERNAME_SUCCESS, USER_SET_REFERRAL_SUCCESS, SCREEN_GENERAL_INTRO, USER_UPDATE_FAIL, USER_UPDATE_SUCCESS, SCHOOL_USER_SET_SUCCESS, SCHOOL_USER_SET, SCHOOL_USER_SET_FAIL, GAME_UPDATE, APP_STARTUP_USER
} from '../constants/action-types';
import config, { ADDRESS_ORACLES_CONTROLLER } from '../config';
import { promises } from 'fs';

function* contractAddAllowance(action) {
}

export default [

]


// WEBPACK FOOTER //
// ./src/sagas/contract.js